import { useState } from "react";
import { Play } from "lucide-react";
import { VIDEOS, SITE } from "../data/stories";
import Reveal from "./Reveal";
import VideoLightbox from "./VideoLightbox";

export const VideosStrip = () => {
  const [active, setActive] = useState(null);

  return (
    <section data-testid="latest-videos" className="bg-[#0E0E0E] text-white">
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 py-16 sm:py-20">
        <Reveal>
          <div className="flex items-end justify-between gap-6">
            <div>
              <h2 className="font-display text-3xl sm:text-4xl font-semibold">
                Latest Videos
              </h2>
            </div>
            <a
              href={SITE.socials.youtube}
              target="_blank"
              rel="noreferrer"
              data-testid="videos-channel-link"
              className="hidden sm:inline-block text-[11px] font-bold uppercase tracking-[0.2em] text-white/60 hover:text-white transition-colors border-b border-white/20 pb-1"
            >
              Visit our channel
            </a>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {VIDEOS.map((video, i) => (
            <Reveal key={video.id} delay={i * 0.08}>
              <button
                type="button"
                onClick={() => setActive(video)}
                aria-label={`Play video: ${video.title}`}
                data-testid={`video-card-${video.id}`}
                className="group relative block w-full text-left overflow-hidden rounded-[5px] aspect-video bg-neutral-900 cursor-pointer"
              >
                <img
                  src={video.img}
                  alt={video.imgAlt}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover opacity-80 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
                <span className="absolute top-3 left-3 bg-[#cf0a0a] text-white text-[9px] font-extrabold uppercase tracking-[0.2em] px-2 py-1">
                  {video.kicker ? `INTV · ${video.kicker}` : "Video"}
                </span>
                <span className="absolute inset-0 m-auto w-14 h-14 rounded-full bg-[#cf0a0a]/95 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                  <Play size={20} fill="white" className="text-white ml-0.5" />
                </span>
                <h3 className="absolute bottom-0 left-0 right-0 p-4 font-display text-lg leading-snug font-medium">
                  {video.title}
                </h3>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <VideoLightbox video={active} onClose={() => setActive(null)} />
    </section>
  );
};

export default VideosStrip;
